import React from 'react';
import {Modal, Text, Icon} from '@/ui-kits';
import {AccessModule} from '@/interface';

interface AccessPermissionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  roleName: string;
  accessPermissions: AccessModule[];
}

export const AccessPermissionsModal: React.FC<AccessPermissionsModalProps> = ({isOpen, onClose, roleName, accessPermissions}) => {
  if (!isOpen) return null;

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className="rounded-xl w-[95vw] sm:w-[85vw] md:w-[75vw] lg:w-[65vw] xl:w-[55vw] 2xl:w-[50vw] max-w-[600px] bg-white p-0 overflow-hidden border-[1px] border-ui_input_border">
      <div className="flex flex-col h-full max-h-[85vh] sm:max-h-[80vh]">
        {/* Header */}
        <div className="flex items-start justify-between px-4 sm:px-6 py-3 sm:py-4 pb-2 bg-white gap-2">
          <Text variant="free" className="text-ui_blue font-FigtreeBold text-base sm:text-lg lg:text-xl break-words pr-2 flex-1 min-w-0">
            Access Assigned to Role : {roleName}
          </Text>
          <button
            onClick={onClose}
            className="text-ui_blue hover:text-ui_blue_light transition-colors p-1.5 rounded-full hover:bg-gray-100 flex-shrink-0 mt-0.5"
            title="Close">
            <Icon type="close" className="size-5 sm:size-6" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-3 sm:px-4 md:px-6 pb-4 sm:pb-6 pt-2 min-h-0">
          <div className="w-full border-[1px] border-ui_input_border rounded-lg overflow-hidden">
            <div className="max-h-[calc(80vh-200px)] overflow-y-auto">
              {accessPermissions.length > 0 ? (
                accessPermissions.map((permission, index) => (
                  <div
                    key={permission.id}
                    className={`flex items-center px-4 sm:px-6 py-3 sm:py-4 bg-ui_sky_blue ${
                      index !== accessPermissions.length - 1 ? 'border-b-[1px] border-b-ui_input_border' : ''
                    }`}>
                    <Icon type="Check_circle" className="size-5 sm:size-6 mr-3 sm:mr-4 flex-shrink-0" />

                    <Text variant="free" className="font-FigtreeSemiBold text-sm sm:text-base text-ui_input_border_dark">
                      {permission.name}
                    </Text>
                  </div>
                ))
              ) : (
                <div className="px-4 sm:px-6 py-6 sm:py-8 text-center bg-ui_sky_blue">
                  <Text variant="body" className="text-ui_input_border_dark">
                    No access permissions found.
                  </Text>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
